import i18n from '@signavio/i18n'

import { Spinner, LegacyHint, Icon, Popover } from '@signavio/ui'

import { useApi } from '../../api'
import types from '../../apiTypes'
import Avatar, { AvatarProps } from './Avatar'

interface UserAvatarProps {
  value: string
  admin?: boolean
  medium?: AvatarProps['medium']
  circular?: AvatarProps['circular']
  disabled?: AvatarProps['disabled']
  micro?: AvatarProps['micro']
  small?: AvatarProps['small']
  large?: AvatarProps['large']
}

function UserAvatar({ value, admin, ...rest }: UserAvatarProps) {
  const [fetchUserRequestState] = useApi(types.USER, {
    query: {
      id: value,
      admin,
    },
  })

  if (fetchUserRequestState.rejected) {
    return (
      <Popover
        position="top"
        popover={<LegacyHint inline>{i18n('Failed to load user.')}</LegacyHint>}
      >
        <Icon data-testid="error-icon" icon="error" />
      </Popover>
    )
  }

  if (fetchUserRequestState.pending || !fetchUserRequestState.value) {
    return <Spinner data-testid="loading-spinner" />
  }

  return <Avatar {...rest} admin={admin} user={fetchUserRequestState.value} />
}

export default UserAvatar
